/**
 * POST `admin/clients/:id/admin-phone` — сменить номер администратора
 * (логин владельца). Код из SMS клиент вводит сам при входе.
 */

import {apiEnabled, http} from '@services/utils';
import {formatKgPhone, phoneDigits, toE164} from '@utils/phone';

import {MOCK_CLIENTS} from '../mocks';

export type ChangeAdminPhoneInput = {id: string; newPhone: string};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const changeAdminPhone = async (input: ChangeAdminPhoneInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((cl) => cl.id === input.id);
    if (row) row.adminPhone = `+996 ${formatKgPhone(phoneDigits(input.newPhone))}`;
    return {ok: true};
  }

  await http(`admin/clients/${encodeURIComponent(input.id)}/admin-phone`, {
    method: 'POST',
    body: {newPhone: toE164(input.newPhone)},
    skipCaseConversion: true,
  });
  return {ok: true};
};
